import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { isClinicianAppLocation } from './runtimeMode';
import { clearClinicianServiceWorker, registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

const bootstrap = async () => {
  const shouldRenderClinicianApp = isClinicianAppLocation(window.location);
  const { default: RootApp } = shouldRenderClinicianApp
    ? await import('./clinician/ClinicianApp')
    : await import('./App');

  if (shouldRenderClinicianApp) {
    clearClinicianServiceWorker();
  } else {
    registerServiceWorker();
  }

  root.render(
    <React.StrictMode>
      <RootApp />
    </React.StrictMode>
  );
};

bootstrap();
